import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { RegisterUserService } from './../../../services/registerUser/register-user.service';
import { UserblockService } from './userblock.service';
import { CommonFunctionService } from '../../../services/Common/common-function.service';
import { Store } from '@ngrx/store';
import {
  selectMerchantDetails,
  selectMerchantKeyValidation,
} from 'src/app/store/selectors/auth.selectors';
import { MerchantDetails } from 'src/app/store/model/auth.model';
import {
  checkMerchantKeyId,
  loadMerchantDetails,
} from 'src/app/store/action/auth.actions';
import { Router } from '@angular/router';
@Component({
  selector: 'app-userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss'],
})
export class UserblockComponent implements OnInit {
  user: any;
  ResellerId: any;
  image: boolean = false;
  resellername: boolean = false;
  fastswiffimage: boolean = true;
  whitelabelname: any;
  content;
  merchantdata: any;
  merchantKeyValidation$ = this.store.select(selectMerchantKeyValidation);

  CompanyName: any;
  MId: any;
  LogoContent: any;
  PaygLogo: boolean;
  MerchantLogo: boolean;
  Success: number;
  showActive: boolean = false;
  profilemenu: boolean = false;
  merchant$ = this.store.select(selectMerchantDetails);
  constructor(
    public userblockService: UserblockService,
    private commonfunction: CommonFunctionService,
    private store: Store<any>,
    private registerUserService: RegisterUserService,
    private eRef: ElementRef,
    private router: Router
  ) {
    this.user = {
      picture: 'assets/img/user/01.jpg',
    };
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.profilemenu = false;
    }
  }
  navigateToLogin() {
    localStorage.clear();
    this.router.navigate(['/login']).then(() => {
      window.location.reload();
    });
  }
  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.registerUserService
      .getResellerDetails(this.merchantdata)
      .subscribe((data) => {
        this.registerUserService
          .getboardingdocuments(this.ResellerId, this.merchantdata)
          .subscribe((result) => {
            if (result != null) {
              if (result.Content != null && data.WhiteLabelType != 0) {
                this.content = result.Content;
                this.image = true;
                this.fastswiffimage = false;
              } else {
                this.image = false;
                this.fastswiffimage = true;
              }
            } else {
              this.image = false;
              this.fastswiffimage = true;
            }
          });
      });

    this.ResellerId = this.commonfunction.getUserMerchantData().ResellerId;
    this.merchantdata = this.commonfunction.getUserMerchantData().MerchantKeyId;

    this.store.dispatch(
      checkMerchantKeyId({
        merchantKeyId: this.merchantdata,
        resellerId: this.ResellerId,
      })
    );
    this.merchantKeyValidation$.subscribe((success: any | null) => {
      if (success == 5) {
        this.showActive = true;
      }
    });
    const action = loadMerchantDetails();

    console.log('Dispatching action:', action);
    this.store.dispatch(action);
    this.merchant$.subscribe((merchant: MerchantDetails | null) => {
      if (merchant) {
        this.MId = merchant.MID;
        this.CompanyName = merchant.CompanyName;
      }
    });

    // this.registerUserService.GetMerchantOnboardStatus().subscribe((response) => {
    //     // Extract CurrentTransaction value from the response
    //   //  console.log(response)

    //      this.MId= response.Data.MID;
    //     this.CompanyName = response.Data.CompanyName;

    //   });
    this.registerUserService
      .getMerchantLogoInfo(this.merchantdata)
      .subscribe((res) => {
        this.LogoContent = res;
        if (
          this.LogoContent.length != 0 &&
          this.LogoContent.length != undefined
        ) {
          if (
            res[0].Content != 'NULL' ||
            res[0].Content != '' ||
            res[0].Content != undefined
          ) {
            // if(result[0] .Length == "null" )
            this.content = res[0].Content;
            localStorage.setItem('MerchantLogo', this.content);
            this.PaygLogo = false;
            this.MerchantLogo = true;
          }
        } else {
          this.merchantdata =
            this.commonfunction.getUserMerchantData().MerchantKeyId;
          this.registerUserService
            .getResellerDetails(this.merchantdata)
            .subscribe((data) => {
              if (data.WhiteLabelType != 0) {
                this.registerUserService
                  .getboardingdocuments(this.ResellerId, this.merchantdata)
                  .subscribe((result) => {
                    this.content = result.Content;
                    this.PaygLogo = false;
                    this.MerchantLogo = true;
                  });
              } else {
                this.PaygLogo = true;
                this.MerchantLogo = false;
              }
            });
        }
      });
  }

  userBlockIsVisible() {
    return this.userblockService.getVisibility();
  }

  toggleDropdown() {
    console.log('good');
    this.profilemenu = !this.profilemenu;
    console.log(this.profilemenu, 'hi');
  }
}
